import { useLazyQuery } from '@apollo/client/react';

import { useTranscriptFormattingPortFromQuery } from '@/shared-responder-v2';
import type { TranscriptFormattingPort } from '@/shared-responder-v2-core';
import { FORMAT_TRANSCRIPT_ANSWER } from '@/survey-graphql';

// test-exception: Apollo binding only — the port and the request shape are useTranscriptFormattingPortFromQuery and toTranscriptFormatQueryInput, covered by shared-responder-v2-transcript-format-port.hooks.spec.tsx and shared-responder-v2-transcript-format.helpers.spec.ts; the literal it sends is checked against survey QuestionType at typecheck.
export function useSurveyTranscriptFormattingPort(): TranscriptFormattingPort {
  const [formatTranscript] = useLazyQuery(FORMAT_TRANSCRIPT_ANSWER, {
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  return useTranscriptFormattingPortFromQuery(formatTranscript);
}
